import React from 'react';

export default function FieldFeedback(props) {
  let feedbackClass = props.className;
  let feedbackIcon = props.iconClassName;

  if ('valid' in props) {
    feedbackClass = 'color-success';
    feedbackIcon = 'fa-check-circle';
  } else if ('invalid' in props) {
    feedbackClass = 'color-danger';
    feedbackIcon = 'fa-times-circle';
  }

  let message = null;
  if ('feedback_message' in props) {
    message = props.feedback_message;
  } else if ('message' in props) {
    message = props.message;
  }

  feedbackClass += ' feedback mt-1';
  feedbackIcon += ' fa';

  return (
    <div className={feedbackClass}>
      <div className="icon">
        <i className={feedbackIcon} aria-hidden="true" />
        {message}
      </div>
    </div>
  );
}
